import { getCurrentLanguage } from '../../containers/LanguageSwitcher/config';
const actions = {
  CHANGE_LANGUAGE_REQUEST: 'CHANGE_LANGUAGE_REQUEST',
  CHANGE_LANGUAGE_SUCCESS: 'CHANGE_LANGUAGE_SUCCESS',
  CHANGE_LANGUAGE_ERROR: 'CHANGE_LANGUAGE_ERROR',
  ACTIVATE_LANG_MODAL: 'ACTIVATE_LANG_MODAL',
  switchActivation: () => ({
    type: actions.ACTIVATE_LANG_MODAL
  }),
  changeLanguage: language => {
    return {
      type: actions.CHANGE_LANGUAGE_REQUEST,
      language: getCurrentLanguage(language)
    };
  }
};
export default actions;
